import React from 'react'
import styles from './password-required.styles'
import injectSheet from 'react-jss'
import Wrapper from '../../../../wrapper/wrapper'
import Container from '../../../../container/container'
import Description from '../../../../description/description'
import duck from '../../../../images/su-duck.gif'
import bear from '../../../../images/su-bear.gif'
import dinosaur from '../../../../images/su-dinosaur.png'
import Form from './form/form.container'

const accountTypeMap = {
  teacher: {
    title: 'Complete your account',
    containerProps: { primary: true, img: duck }
  },
  user: {
    title: 'Join Pobble as a parent',
    containerProps: { secondary: true, img: bear }
  },
  notChosen: {
    title: 'Join Pobble today',
    containerProps: { neutral: true, img: dinosaur }
  }
}

const PasswordRequired = ({ classes, accountType, options }) => {
  const accountData = accountTypeMap.teacher
  return (
    <Wrapper>
      <Container {...accountData.containerProps}>
        <Description title={accountData.title} />
        <Form email={options.email} />
      </Container>
    </Wrapper>
  )
}

export default injectSheet(styles)(PasswordRequired)
